import { useState } from 'react';

const getUserShouldBePromptedToInstall = ( promptName, daysToWaitBeforePromptingAgain ) =>  {

    const lastPrompted     = new Date( localStorage.getItem( promptName ) );
    const promptExpiration = new Date();

    promptExpiration.setDate( promptExpiration.getDate() - daysToWaitBeforePromptingAgain );

    return lastPrompted < promptExpiration;

}

const useShouldShowPrompt = ( promptName, daysToWaitBeforePromptingAgain = 30 ) => {

    const [ userShouldBePromptedToInstall, setUserShouldBePromptedToInstall ] = useState(

        getUserShouldBePromptedToInstall( promptName, daysToWaitBeforePromptingAgain )

    );

    const handleUserSeeingInstallPrompt = () => {

        setUserShouldBePromptedToInstall( false );
        localStorage.setItem( promptName, ( new Date() ).toJSON() );

    };

    return [ userShouldBePromptedToInstall, handleUserSeeingInstallPrompt ];

};

export default useShouldShowPrompt;